import { api, publicApi } from './client';

export interface AuthUser {
  account_id: string;
  email: string;
  name: string | null;
  role: 'admin' | 'standard';
}

export async function fetchNonce(): Promise<string> {
  const res = await publicApi.post<{ nonce: string }>('/api/auth/nonce');
  return res.data.nonce;
}

export async function signInWithGoogle(idToken: string): Promise<AuthUser> {
  const res = await api.post<AuthUser>('/api/auth/google', { id_token: idToken });
  return res.data;
}

export async function fetchMe(): Promise<AuthUser> {
  const res = await api.get<AuthUser>('/api/auth/me');
  return res.data;
}

export async function logout(allDevices = false): Promise<void> {
  await api.post('/api/auth/logout', { all_devices: allDevices });
}
